import { fetchData } from "@client";

export async function getTemplateQuery(id) {
  const { results } = await fetchData(`/template/without-structure/${id}`);
  return results;
}
